/*
 * ReportsWrapper — iter320
 * ---------------------------------------------------------------------------
 * Adds tabbed navigation over the existing Reports page. The `Report` tab
 * still renders the untouched `<Reports/>` page; the new `Dashboard` tab
 * (default) renders `<ReportsDashboard/>`.
 *
 * The wrapper never touches Reports.js — the existing Report tab keeps
 * all its filters, cards, custom-report configuration and APIs.
 */
import React, { useState } from 'react';
import Reports from './Reports';
import ReportsDashboard from './ReportsDashboard';

const ReportsWrapper = () => {
  const [tab, setTab] = useState('dashboard'); // dashboard | report

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1" data-testid="reports-tab-switch">
          <button
            onClick={() => setTab('dashboard')}
            className={`px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${tab === 'dashboard' ? 'bg-white text-teal-700 shadow-sm' : 'text-gray-600 hover:text-gray-800'}`}
            data-testid="reports-tab-dashboard"
          >Dashboard</button>
          <button
            onClick={() => setTab('report')}
            className={`px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${tab === 'report' ? 'bg-white text-teal-700 shadow-sm' : 'text-gray-600 hover:text-gray-800'}`}
            data-testid="reports-tab-report"
          >Report</button>
        </div>
      </div>
      {tab === 'dashboard' ? <ReportsDashboard /> : <Reports />}
    </div>
  );
};

export default ReportsWrapper;
